<div class="ai-chat-panel" [style.width.px]="panelWidth">
  <div class="resize-handle" [class.dragging]="dragging" (mousedown)="onResizeStart($event)"></div>
  <div class="ai-chat-header">
    <div class="ai-chat-title-group">
      <span class="ai-chat-title">Valumize Assistant</span>
      <span class="preview-badge"
            matTooltip="This feature is provided as a preview and is not yet part of the officially released product scope. Functionality and results may change prior to full release. We recommend validating results before operational use."
            matTooltipClass="preview-tooltip">Preview</span>
    </div>
    <button mat-icon-button (click)="closePanel()" aria-label="Close chat panel">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="ai-chat-messages" #messagesContainer>
    @for (message of messages$ | async; track message.timestamp) {
      <div class="ai-chat-message" [class.user]="message.role === 'user'" [class.assistant]="message.role === 'assistant'">
        @if (message.role === 'user') {
          <div class="message-content user-message">{{ message.content }}</div>
        } @else {
          <div class="message-content assistant-message" (click)="onMessageClick($event)">
            <markdown [data]="message.content" [katex]="true"></markdown>
          </div>

          @if (message.entityReferences?.length) {
            <div class="entity-refs">
              @for (ref of message.entityReferences; track ref.id) {
                <mat-chip-option (click)="navigateToEntity(ref)" [selectable]="false" highlighted>
                  <mat-icon matChipAvatar>
                    @switch (ref.type) {
                      @case ('fund') { account_balance }
                      @case ('asset') { business }
                      @case ('deal') { handshake }
                    }
                  </mat-icon>
                  {{ ref.name }}
                </mat-chip-option>
              }
            </div>
          }

          @if (message.suggestedActions?.length) {
            <div class="suggested-actions">
              @for (action of message.suggestedActions; track action.id) {
                <button mat-stroked-button class="action-card" (click)="sendSuggestedAction(action.triggerPrompt)">
                  <span class="action-label">{{ action.label }}</span>
                  @if (action.description) {
                    <span class="action-description">{{ action.description }}</span>
                  }
                </button>
              }
            </div>
          }
        }
      </div>
    }

    @if (isStreaming$ | async) {
      @let toolCall = toolCallStatus$ | async;
      @let streamingText = streamingText$ | async;

      @if (toolCall && !streamingText) {
        <div class="tool-status-info">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          <span class="tool-status-text">{{ toolCall.tool }}...</span>
        </div>
      }

      @if (streamingText) {
        <div class="ai-chat-message assistant">
          <div class="message-content assistant-message" (click)="onMessageClick($event)">
            <markdown [data]="streamingText" [katex]="true"></markdown>
          </div>
        </div>
      } @else if (!toolCall) {
        <div class="typing-indicator">
          <span></span><span></span><span></span>
        </div>
      }
    }

    @if (error$ | async; as error) {
      <div class="ai-chat-error">
        <mat-icon>error_outline</mat-icon>
        <div class="error-content">
          @if (error.includes('404')) {
            <span>The AI assistant is currently unavailable. Please try again later or contact support.</span>
          } @else if (error.includes('401') || error.includes('403')) {
            <span>Not authorized. Please log in again.</span>
          } @else {
            <span>Something went wrong. Please try again or contact support.</span>
          }
          <button mat-stroked-button class="error-retry" (click)="retryLastMessage()">
            <mat-icon>refresh</mat-icon>
            Retry
          </button>
        </div>
      </div>
    }
  </div>

  <div class="ai-chat-input">
    <mat-form-field appearance="outline" class="chat-input-field" subscriptSizing="dynamic">
      <textarea matInput
                [formControl]="chatForm.controls.message"
                [maxlength]="maxMessageLength"
                placeholder="Enter a message..."
                (keydown)="onKeyDown($event)"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="4">
      </textarea>
      <button mat-icon-button matSuffix (click)="sendMessage()" [disabled]="isStreaming$ | async">
        <mat-icon>send</mat-icon>
      </button>
      <mat-hint align="end" *ngIf="chatForm.controls.message.value && chatForm.controls.message.value.length > maxMessageLength * 0.9">
        {{chatForm.controls.message.value.length}} / {{maxMessageLength}}
      </mat-hint>
    </mat-form-field>
    <p class="ai-disclaimer">AI can make mistakes. Always verify important information.</p>
  </div>
</div>
